import React, { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { getCanonicalAffiliateName } from "../lib/affiliateIdentity";

const ProtectedAdminRoute = () => {
  const { user, isAdmin, loading, isRoleLoading, profile } = useAuth();

  // Debug logging
  useEffect(() => {
    console.log("=== ProtectedAdminRoute Debug ===");
    console.log("user:", user);
    console.log("user.email:", user?.email);
    console.log("isAdmin:", isAdmin);
    console.log("loading:", loading);
    console.log("isRoleLoading:", isRoleLoading);
    console.log("profile:", profile);
    console.log("profile?.is_admin:", profile?.is_admin);
    console.log("==================================");
  }, [user, isAdmin, loading, isRoleLoading, profile]);

  // TEMPORARY: Manual admin override for testing
  // TODO: Remove this after fixing the database
  const isManualAdmin = user?.email === "bashirkamran18@gmail.com"; // Your actual admin email

  // Check if we're still loading - include both auth loading and role loading
  // Also ensure we don't redirect while we're still determining admin status
  if (loading || isRoleLoading || (user && !profile && !isManualAdmin)) {
    console.log(
      "ProtectedAdminRoute - Still loading or determining admin status..."
    );
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  if (!user) {
    console.log("ProtectedAdminRoute - No user, redirecting to login");
    return <Navigate to="/login" />;
  }

  // Use manual admin override if database admin check fails
  const finalIsAdmin = isAdmin || isManualAdmin;

  if (!finalIsAdmin) {
    console.log(
      "ProtectedAdminRoute - Not admin, redirecting to affiliate page"
    );
    console.log("Database isAdmin:", isAdmin);
    console.log("Manual override:", isManualAdmin);
    console.log("Profile loaded:", !!profile);

    // Non-admin users get redirected to their affiliate page
    const affiliateName = getCanonicalAffiliateName(profile, user);
    return <Navigate to={`/affiliate/${affiliateName}`} />;
  }

  console.log("ProtectedAdminRoute - Admin user, allowing access");
  console.log("Using manual override:", isManualAdmin);
  console.log("Database admin status:", isAdmin);

  // Admin users can access the protected admin routes
  return <Outlet />;
};

export default ProtectedAdminRoute;
